import * as React from "react";
import { createRoot } from "react-dom/client";

import "react-loading-skeleton/dist/skeleton.css";

import App from "./App";
import { initializeBranding } from "./utils/Branding";

initializeBranding();

const container = document.getElementById("app");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);
